import { useTheme } from '../context/ThemeContext';
import { Download, Car, CheckCircle } from 'lucide-react';

const HowItWorks = () => {
  const theme = useTheme();

  const steps = [
    {
      icon: Download,
      number: '01',
      title: 'Download',
      description: 'Get TripData free on iOS or Android.'
    },
    {
      icon: Car,
      number: '02',
      title: 'Drive',
      description: 'Start a trip and go. GPS tracks automatically in the background.'
    },
    {
      icon: CheckCircle,
      number: '03',
      title: 'Review',
      description: 'See your trips, categorize them, and export when ready.'
    }
  ];

  return (
    <section 
      id="how-it-works" 
      className="py-32"
      style={{ backgroundColor: theme.card }}
    >
      <div className="container-app">
        
        {/* Header */}
        <div className="text-center mb-24">
          <h2 
            className="text-responsive-lg font-bold tracking-tight mb-6"
            style={{ color: theme.text }}
          >
            Simple as{' '}
            <span className="gradient-text">1, 2, 3</span>
          </h2>
          <p 
            className="text-xl max-w-xl mx-auto"
            style={{ color: theme.textSecondary }}
          >
            Start tracking in seconds. No setup, no hassle.
          </p>
        </div>

        {/* Steps */}
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-3 gap-16 md:gap-8 relative">
            
            {/* Connecting line - desktop only */}
            <div 
              className="hidden md:block absolute top-10 left-1/6 right-1/6 h-px"
              style={{ 
                background: `linear-gradient(90deg, transparent, ${theme.border}, ${theme.border}, transparent)` 
              }}
            />

            {steps.map((step, index) => (
              <div key={index} className="text-center relative">
                {/* Icon */}
                <div 
                  className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-6 bg-gradient-brand"
                  style={{ boxShadow: '0 4px 12px rgba(0, 0, 0, 0.25)' }}
                >
                  <step.icon className="w-8 h-8 text-white" />
                </div>

                {/* Content */}
                <h3 
                  className="text-xl font-semibold mb-3"
                  style={{ color: theme.text }}
                >
                  {step.title}
                </h3>
                <p 
                  className="text-base"
                  style={{ color: theme.textMuted }}
                >
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom visual - app flow hint */}
        <div className="mt-24 text-center">
          <div 
            className="inline-flex items-center gap-3 px-6 py-3 rounded-full"
            style={{ backgroundColor: theme.background }}
          >
            <span 
              className="w-2 h-2 rounded-full bg-gradient-brand animate-pulse"
            />
            <span 
              className="text-sm"
              style={{ color: theme.textSecondary }}
            >
              Average setup time: 30 seconds
            </span>
          </div>
        </div>

      </div>
    </section>
  );
};

export default HowItWorks;